import { errorMsg } from '../utils/errorMsg';
import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Box, Alert, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import StartForm from '../components/StartForm';
import api from '../axios';

export default function CadastroAluno() {
	const navigate = useNavigate();
	const [form, setForm] = useState({
		nome: '',
		email: '',
		senha: '',
	});
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [successMsg, setSuccessMsg] = useState('');
	const [error, setError] = useState('');

	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError('');
		setSuccess(false);
		
		
		try {
			// SOLUÇÃO TEMPORÁRIA: Enviar como query params E body JSON
			// Produção antiga espera query params, código novo espera JSON body
			const params = new URLSearchParams({
				nome: form.nome,
				email: form.email,
				senha: form.senha
			});
			
			const res = await api.post(`/cadastro-aluno/?${params.toString()}`, form);
			
			
			setSuccess(true);
			setSuccessMsg(res.data.msg || 'Cadastro realizado com sucesso!');
			setForm({ nome: '', email: '', senha: '' });
			
			// Redirecionar para login após 5 segundos
			setTimeout(() => {
				navigate('/login');
			}, 5000);
			
		} catch (err) {
			console.error('❌ Erro completo:', err);
			console.error('📋 Resposta do servidor:', err.response?.data);
			console.error('🔢 Status:', err.response?.status);
			console.error('📊 Headers:', err.response?.headers);
			
			if (errorMsg(err)) {
				// Se for array de erros de validação
				if (Array.isArray(err.response.data.detail)) {
					console.error('🔍 Erros de validação:', err.response.data.detail);
					const errors = err.response.data.detail.map(e => {
						return e.msg || JSON.stringify(e);
					}).join(', ');
					setError(errors);
				} else {
					setError(err.response.data.detail);
				}
			} else {
				setError('Erro ao realizar cadastro. Tente novamente.');
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Header />
			<Container maxWidth="sm" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
				<StartForm
					title="Cadastro de Aluno"
					description="Preencha seus dados básicos para criar sua conta. Após a aprovação do administrador, você poderá completar seu cadastro."
					onBack={() => navigate('/login')}
				>
					{success && (
						<Alert severity="success" sx={{ mb: 2 }}>
							{successMsg}
							<br />
							<Typography variant="body2" sx={{ mt: 1 }}>
								Você será redirecionado para o login em 5 segundos...
							</Typography>
						</Alert>
					)}

					{error && (
						<Alert severity="error" sx={{ mb: 2 }}>
							{error}
						</Alert>
					)}

					<Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<TextField
									label="Nome Completo"
									name="nome"
									value={form.nome}
									onChange={handleChange}
									fullWidth
									required
									helperText="Digite seu nome completo"
								/>
							</Grid>

							<Grid item xs={12}>
								<TextField
									label="E-mail"
									name="email"
									value={form.email}
									onChange={handleChange}
									fullWidth
									required
									type="email"
									helperText="Este será seu login no sistema"
								/>
							</Grid>

							<Grid item xs={12}>
								<TextField
									label="Senha"
									name="senha"
									value={form.senha}
									onChange={handleChange}
									fullWidth
									required
									type="password"
									helperText="Mínimo de 6 caracteres"
								/>
							</Grid>

							<Grid item xs={12}>
								<Button
									type="submit"
									variant="contained"
									color="primary"
									fullWidth
									aria-label="Cadastrar aluno"
									disabled={loading}
									sx={{ py: 1.5 }}
								>
									{loading ? 'Cadastrando...' : 'Cadastrar'}
								</Button>
							</Grid>
						</Grid>

						<Box sx={{ mt: 2, textAlign: 'center' }}>
							<Typography variant="body2" color="text.secondary">
								Já tem uma conta?{' '}
								<Button 
									variant="text" 
									color="primary" 
									onClick={() => navigate('/login')}
									sx={{ textTransform: 'none' }}
								>
									Fazer Login
								</Button>
							</Typography>
						</Box>
					</Box>
				</StartForm>
			</Container>
			<Footer />
		</>
	);
}
